import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classes from "./ActiveUsers.module.scss";
import { getActiveUsers } from "../../config/LiveApi";
import { changeAnchor } from "../../helpers/change-anchors";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { FaMinus, FaTimes, FaPlus } from "react-icons/fa";
import './ActiveUsers.css';

const ActiveUsers = ({ open, anchor, onClose }) => {
    const token = useSelector((store) => store.userReducer.token);
    const [payinUsers, setPayinUsers] = useState([]);
    const [payoutUsers, setPayoutUsers] = useState([]);
    const [minimized, setMinimized] = useState(false);

    useEffect(() => {
        const fetchActiveUsersData = async () => {
            try {
                const response = await getActiveUsers(token);
                // console.log("Active Users Data", response);
                setPayinUsers(response.activePayinUsers || []);
                setPayoutUsers(response.activePayoutUsers || []);
            } catch (err) {
                toast.error(err.message);
                setPayinUsers([]);
                setPayoutUsers([]);
            }
        };
        fetchActiveUsersData();
    }, [token]);

    const handleToggleMinimize = () => {
        setMinimized(prev => !prev);
    };

    return (
        <>
            <div
                className={`${classes.overlay} ${!open ? classes.overlayHidden : classes.overlayOpen}`}
                aria-hidden="true"
                // onClick={onClose}
            />
            <div
                tabIndex="-1"
                className={`main-side-css ${classes.drawer} ${open ? classes.animate : classes.hidden} ${changeAnchor(anchor, classes)}`}
                style={{
                    position: "fixed",
                    height: minimized ? "20%" : "80%",
                    top: minimized ? "80%" : "20%",
                    overflowY: "auto",
                    borderRadius: "10px",
                    padding: "10px",
                    backgroundColor: "#f9f9f9"
                }}
            >
                <div className="live-close-minimize">
                    <button className="live-modal-buttons-close mini" onClick={handleToggleMinimize}>
                        {minimized ? <FaPlus /> : <FaMinus />}
                    </button>
                    <button className="live-modal-buttons-close" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div
                    className={classes.header}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#fc8019",
                        color: "#fff",
                        borderRadius: "10px 10px 0 0"
                    }}
                >
                    <h4>Live Merchants</h4>
                </div>

                {(payinUsers.length > 0) && (
                    <div style={{ marginBottom: "10px" }}>
                        <h4 style={{ textAlign: "center", color: "black",padding:'10px' }}>Active Payin Users</h4>
                        {!minimized && (
                            <table className="users-table" style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "#fff", borderRadius: "10px", overflow: "hidden" }}>
                                <thead>
                                    <tr style={{ backgroundColor: "#fc8019", color: "white" }}>
                                        <th style={{ padding: "10px", fontSize: "12px" }}>Merchant Name</th>
                                        <th style={{ padding: "10px", fontSize: "12px" }}>Provider</th>
                                        <th style={{ padding: "10px", fontSize: "12px" }}>Org Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {payinUsers.map((merchant) => (
                                        <tr key={merchant.name} style={{ borderBottom: "1px solid #ddd" }}>
                                            <td style={{ padding: "5px", textAlign: "center", fontSize: "10px" }}>{merchant.alias || merchant.userId}</td>
                                            <td style={{ padding: "5px", textAlign: "center", fontSize: "10px" }}>{merchant.provider}</td>
                                            <td style={{ padding: "5px", textAlign: "center", fontSize: "10px" }}>{merchant.org}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                )}

                {(payoutUsers.length > 0 ) && (
                    <div>
                        <h4 style={{ textAlign: "center", color: "black",padding:'10px' }}>Active Payout Users</h4>
                        {!minimized && (
                            <table className="users-table" style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "#fff", borderRadius: "10px", overflow: "hidden" }}>
                                <thead>
                                    <tr style={{ backgroundColor: "#fc8019", color: "white" }}>
                                        <th style={{ padding: "10px", fontSize: "14px" }}>Merchant Name</th>
                                        <th style={{ padding: "10px", fontSize: "14px" }}>Provider</th>
                                        <th style={{ padding: "10px", fontSize: "14px" }}>Org Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {payoutUsers.map((merchant) => (
                                        <tr key={merchant.name} style={{ borderBottom: "1px solid #ddd" }}>
                                            <td style={{ padding: "10px", textAlign: "center", fontSize: "12px" }}>{merchant.alias || merchant.userId}</td>
                                            <td style={{ padding: "10px", textAlign: "center", fontSize: "12px" }}>{merchant.provider}</td>
                                            <td style={{ padding: "10px", textAlign: "center", fontSize: "12px" }}>{merchant.org}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

ActiveUsers.propTypes = {
    open: PropTypes.bool.isRequired,
    anchor: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ActiveUsers;